import { IconLayer } from '@deck.gl/layers';
import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import spriteMapping from '@rsos/components/capstone/common/Map/assets/calls/sprites-output/sprites-info.json';
import callsSprite from '@rsos/components/capstone/common/Map/assets/calls/sprites-output/sprites_2x.png';
import layers from '../storeLayers';

const GEO_SELECTION_PIN_LAYER_ID = 'geo-selection-pin';

const MARKER_SIZES = {
  sizeScale: 60, // this is the factor to scale the icon.
  sizeMinPixels: 38, // when zoomed out, the max height of the icon.
  sizeMaxPixels: 40, // when zoomed in, the max height of the icon.
};

/**
 * Pins a form's map-picked location (`geoSelection[key].pinnedLocation`), e.g.
 * the tow request location chosen through the SelectLocationBanner.
 */
const useGeoSelectionPinGL = ({ overlay }) => {
  const pinnedLocations = useSelector(
    state =>
      Object.values(state.geoSelection ?? {})
        .map(selection => selection.pinnedLocation)
        .filter(Boolean),
    shallowEqual,
  );

  // Build a new layer on every run: deck.gl layer instances are single-use, so
  // handing the same instance to a recreated overlay fails its initialization.
  useEffect(() => {
    if (!overlay) return;

    layers.save(
      new IconLayer({
        id: GEO_SELECTION_PIN_LAYER_ID,
        data: pinnedLocations,
        getPosition: d => [d.longitude, d.latitude],
        // Not pickable, so the pin never swallows the click that re-picks the
        // location while map selection is active.
        pickable: false,
        iconAtlas: callsSprite,
        iconMapping: spriteMapping,
        sizeUnits: 'meters',
        ...MARKER_SIZES,
        getIcon: () => 'historic_call_marker', // matches entry in iconMapping
        visible: true,
      }),
    );
    overlay.setLayers(layers.getAll());
  }, [overlay, pinnedLocations]);
};

const GeoSelectionPinGL = React.memo(({ overlay }) => {
  useGeoSelectionPinGL({ overlay });
  return <></>;
});

export default GeoSelectionPinGL;
